import { render, staticRenderFns } from "./audio_detail.vue?vue&type=template&id=d15e0e28&scoped=true"
import script from "./audio_detail.vue?vue&type=script&lang=js"
export * from "./audio_detail.vue?vue&type=script&lang=js"
import style0 from "./audio_detail.vue?vue&type=style&index=0&id=d15e0e28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d15e0e28",
  null
  
)

export default component.exports